import Vue from 'vue'
import App from './App.vue'  // 明确添加 .vue 扩展名
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/icon.css'
import '@/assets/scss/index.scss'

// 导入字典工具
import dictUtils from '@/utils/dict'

// 确保 ElementUI 正确安装
Vue.use(ElementUI)
Vue.use(dictUtils)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})